import {
  GET_DISPUTE_BY_ID,
  GET_DISPUTES_SORTED_BY_DATE,
  SET_LOADING,
  DISPUTE_ERROR,
  RETURNED_DATA,
  RETURNED_DATA_ERROR,
} from "../../types";

const DisputeReducer = (state, action) => {
  switch (action.type) {
    case GET_DISPUTE_BY_ID:
      return {
        ...state,
        dispute: action.payload.dispute,
        order: action.payload.order,
        loading: false,
      };

    case GET_DISPUTES_SORTED_BY_DATE:
      return {
        ...state,
        disputes: action.payload.disputes,
        loading: false,
      };

    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };

    case DISPUTE_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case RETURNED_DATA:
      return {
        ...state,
        returnedData: action.payload,
        loading: false,
      };

    case RETURNED_DATA_ERROR:
      return {
        ...state,
        returnedDataError: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default DisputeReducer;